import React from 'react';

import Styled from './ScrollableContainer.styled';
import { StandardContentWrapperProps } from './ScrollableContainer.types';


function StandardContentWrapper({ children }: StandardContentWrapperProps): JSX.Element {
    return (
        <Styled.StandardContentWrapper>
            {children}
        </Styled.StandardContentWrapper>
    );
}

export default StandardContentWrapper;
